"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.REFRESH_TOKEN = exports.refreshUser = exports.setUser = void 0;
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var functions_1 = require("./functions");
var REFRESH_TOKEN = (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation refreshMemberToken {\n    refreshToken {\n      token\n      member {\n        id\n        firstName\n        email\n        surname\n        avatarURL\n        termsAndPrivacy\n        contactPermission\n      }\n    }\n  }\n"], ["\n  mutation refreshMemberToken {\n    refreshToken {\n      token\n      member {\n        id\n        firstName\n        email\n        surname\n        avatarURL\n        termsAndPrivacy\n        contactPermission\n      }\n    }\n  }\n"])));
exports.REFRESH_TOKEN = REFRESH_TOKEN;
var setUser = function (user) {
    return functions_1.isBrowser
        ? window.localStorage.setItem('user', JSON.stringify(user))
        : JSON.stringify(user);
};
exports.setUser = setUser;
var refreshUser = function (client) {
    return new Promise(function (resolve, reject) {
        client
            .mutate({ mutation: REFRESH_TOKEN })
            .then(function (data) {
            var refreshToken = data.data.refreshToken;
            setUser(__assign(__assign({}, refreshToken.member), { token: refreshToken.token, isLoggedIn: true }));
            resolve(refreshToken);
        })
            .catch(function (e) {
            reject(new Error(e));
        });
    });
};
exports.refreshUser = refreshUser;
var templateObject_1;
